import heroMain from '../../assets/raj/prevent-diabeties.jfif';
import heroAltMain from '../../assets/raj/type-1-vs-type-2.avif';
import whatIsImg from '../../assets/raj/what-is-diabeties.webp';
import whatIsSupport from '../../assets/raj/insuline.jfif';
import typesImg from '../../assets/raj/types-of-diabetes.jpg';
import causeImg from '../../assets/raj/cause-of-diabetes.webp';
import symptomImg from '../../assets/raj/human-body-hyperglycemia-diabetes-illustration-symptoms-23874.webp';
import photoImg from '../../assets/raj/type2tretment.jpg';
import effectImg from '../../assets/raj/Dr-Rukiya.webp';
import img1 from '../../assets/raj/fourT.jfif';
import img2 from '../../assets/2d.jpeg';
import img3 from '../../assets/3d.jpeg';
import img4 from '../../assets/raj/treatmrnt.webp';

export const diabetesImages = {
  heroMain,
  heroAltMain,
  whatIsImg,
  whatIsSupport,
  typesImg,
  causeImg,
  symptomImg,
  checkupImg: photoImg,
  photoImg,
  effectImg,
  img1,
  img2,
  img3,
  img4,
};
